// target is the link clicked (anything under .nav-item)
// clazz: online, paper, arena
function updateDropdownTypeToggle(target, clazz, clazzLabelText) {
  target.closest(".nav-item").find(".nav-link").text(clazzLabelText);
  target.closest(".nav-item").find(".nav-link").removeClass("paper arena online");
  target.closest(".nav-item").find(".nav-link").addClass(clazz);
}
window.updateDropdownTypeToggle = updateDropdownTypeToggle
